import { LdsToastContainer, globals, themes } from '@lifebit-ai/lds'
import '@lifebit-ai/lds/dist/index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import { Helmet } from 'react-helmet'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import DownloadPage from 'modules/download/DownloadPage'

import AirlockRoutes from './AirlockRoutes'
import { AppGlobalStyle } from './GlobalStyles'
import AuthContextProvider from './auth/AuthContextProvider'
import AppContainer from './modules/general/app-container/AppContainer'
import Envs, { castToStringOrUseDefault } from './utils/env'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})
const LdsGlobalStyle = globals.GlobalStyle

export const GENERIC_PAGE_TITLE = 'Lifebit Airlock'

const App: React.FC = () => {
  const theme = themes.Light
  const baseUrl = castToStringOrUseDefault(Envs.AIRLOCK_FE_BASE_URL, '/')

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={baseUrl}>
            <AppGlobalStyle />
            <LdsGlobalStyle />
            <Routes>
              <Route path="/download/:resultId" element={<DownloadPage />} />

              <Route
                path="*"
                element={
                  <AuthContextProvider>
                    <LdsToastContainer />
                    <AppContainer>
                      <Helmet>
                        <meta charSet="utf-8" />
                        <title>{GENERIC_PAGE_TITLE}</title>
                      </Helmet>
                      <AirlockRoutes />
                    </AppContainer>
                  </AuthContextProvider>
                }
              />
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </CookiesProvider>
    </ThemeProvider>
  )
}

export default App
